"use strict";

exports.__esModule = true;
exports.default = void 0;
var _setTransition = _interopRequireDefault(require("./setTransition"));
var _transitionStart = _interopRequireDefault(require("./transitionStart"));
var _transitionEnd = _interopRequireDefault(require("./transitionEnd"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _default = {
  setTransition: _setTransition.default,
  transitionStart: _transitionStart.default,
  transitionEnd: _transitionEnd.default
};
exports.default = _default;